module.exports = __webpack_public_path__ + "static/img/book5.3ee73f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/book5.jpg
// module id = PCGa
// module chunks = 1